<template>
  <div>
    <task-filter @change="onChange" />
    <br />
    <a-row v-if="data.length > 0" :gutter="16">
      <a-col v-for="(item, key) in data" :key="key" class="gutter-row" :span="12">
        <task-point-team :source-data="item" />
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { taskPointTeam } from '@/api/data/task';
import TaskFilter from '@/pages/data/task/components/TaskFilter';
import TaskPointTeam from '@/pages/data/task/components/TaskPointTeam';
export default {
  components: { TaskFilter, TaskPointTeam },
  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null
      },
      data: {}
    };
  },
  methods: {
    onChange(checkedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        teams: checkedTeams
      };

      taskPointTeam({ ...this.filterForm, sorter: 'point_count' }).then(res => {
        this.data = [];
        this.data = res.data.items;
      });
    }
  }
};
</script>
